<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="my-3">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="3">
                <el-text-field
                  label="UUID"
                  v-model="mainData['uuid-search-like']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-text-field
                  label="Gautų dokumentų žurnalo numeris"
                  v-model="mainData['journal_no-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Klaida"
                  v-model="mainData['exception-search-custom']"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  append-icon="mdi-account"
                  autocomplete="off"
                  name="date_from"
                  v-model="mainData['failed_at-search-from']"
                  tooltip="Ireg. Pagrindinis. Administravimas. JAR duomenų perdavimas. Data nuo"
                  label="Data nuo"
                  type="text"
                />
              </v-col>
              <v-col cols="12" md="3">
                <el-date-picker
                  append-icon="mdi-account"
                  autocomplete="off"
                  name="date_to"
                  v-model="mainData['failed_at-search-to']"
                  tooltip="Ireg. Pagrindinis. Administravimas. JAR duomenų perdavimas. Data iki"
                  label="Data iki"
                  type="text"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'JarFailedJobsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
    getSearchParamKey() {
      return this.$route.name
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      if (this.searchParams && this.searchParams.route === this.getSearchParamKey) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData() {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.getSearchParamKey,
        mainData: this.mainData,
      })
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.errors.clear()
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData()
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        } 
      })
    },
  },
}
</script>
